export default function (isVisible) {
  if (isVisible) {
    return {};
  } else {
    return {
      display: 'none'
    };
  }
}



// WEBPACK FOOTER //
// ./src/helpers/setVisibility.js